import type { IMediumDto } from '@monofe/apiservice';
import type { INSTANTIATOR_INTERFACES } from '@monofe/apiservice/model/interface/instantiator';
import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';

export enum IDownloadState {
    Undef = 0,
    LoadingDependencies = 1,
    AwaitingLanguageTour = 2,
    Idle = 3,
    PopUpAsk = 4,
    Downloading = 5,
    LastValue = 6,
}

export enum IMediaType {
    Stream = 1,
    Download = 2,
}

export interface IDataResolver {
    get: <
        Interface extends keyof INSTANTIATOR_INTERFACES,
        Entity extends ReturnType<INSTANTIATOR_INTERFACES[Interface]>,
        PrimaryKey extends ReturnType<Entity['primaryKey']>,
    >(
        name: Interface,
        pk: PrimaryKey,
    ) => Promise<Entity>;
    all: <
        Interface extends keyof INSTANTIATOR_INTERFACES,
        Entity extends ReturnType<INSTANTIATOR_INTERFACES[Interface]>,
    >(
        name: Interface,
    ) => Promise<Entity[]>;
    downloadList: () => Promise<IMediumDto[]>;
    urlsForMedium: (medium: IMediumDto, types?: IMediaType[]) => Promise<URL[]>;
    urlContentLength: (url: URL) => Promise<number>;
}

export interface IDownloadTour {
    renderer: () => JSX.Element | null;
    show: () => void;
    hide: () => void;
    isShowing: () => boolean;
    isShowable: () => boolean;
    state: () => IDownloadState;
    dataResolver: () => IDataResolver;
}

export const TYPES = {
    IDownloadTour: Symbol.for('IDownloadTour'),
};

export function injectDownloadTour(
    container: IContainer = injectOrBuildContainer(),
): Readonly<IDownloadTour> {
    return container.get<IDownloadTour>(TYPES.IDownloadTour);
}

export function bindDownloadTour(
    value: IDownloadTour,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IDownloadTour>(TYPES.IDownloadTour, value);
}

export function unbindDownloadTour(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IDownloadTour);
}
